var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6603 4.28512C12.2956 3.90496 11.7044 3.90496 11.3397 4.28512L4.30256 11.6226C4.04977 11.8644 3.94449 12.2313 4.02836 12.5782C4.11223 12.925 4.37174 13.196 4.70428 13.284C5.03682 13.372 5.38884 13.2627 5.62116 12.9995L11.0661 7.32224V19.0262C11.0661 19.564 11.4842 20 12 20C12.5158 20 12.9339 19.564 12.9339 19.0262V7.32224L18.3788 12.9995C18.6112 13.2627 18.9632 13.372 19.2957 13.284C19.6283 13.196 19.8878 12.925 19.9716 12.5782C20.0555 12.2313 19.9502 11.8644 19.6974 11.6226L12.6603 4.28512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.a9655ff75518452ce6baf56c55daa004.svg";
export { ForwardRef as ReactComponent };